"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var createIcon_1 = __importDefault(require("../createIcon"));
var BrandIconCallUs = function (props) {
    return (react_1.default.createElement(createIcon_1.default, __assign({ role: "img", ariaLabel: "CallUs" }, props),
        react_1.default.createElement("title", null, "Call Us"),
        react_1.default.createElement("path", { d: "M107.775 71.325L88.682 42.503h-58.36l-18.343 28.95A21.911 21.911 0 008.57 83.186v.246c0 12.107 9.815 21.921 21.922 21.921h59.003c12.108 0 21.922-9.814 21.922-21.921a21.82 21.82 0 00-3.643-12.107zM60 88.22c-9.471 0-17.143-7.671-17.143-17.143 0-9.471 7.672-17.142 17.143-17.142s17.143 7.671 17.143 17.142c0 9.461-7.682 17.143-17.143 17.143z", fill: "#D44513" }),
        react_1.default.createElement("path", { d: "M42.857 71.078c0-9.45 7.64-17.11 17.079-17.142l.043-11.433H30.32L11.98 71.453A21.911 21.911 0 008.57 83.186v.246c0 12.107 9.815 21.921 21.922 21.921h29.282l.054-17.153c-9.386-.086-16.972-7.714-16.972-17.122z", fill: "#FF6E00" }),
        react_1.default.createElement("path", { d: "M94.286 59.646c9.467 0 17.143-7.675 17.143-17.142 0-9.468-7.676-17.143-17.143-17.143-9.468 0-17.143 7.675-17.143 17.143 0 9.467 7.675 17.142 17.143 17.142zM25.714 59.646c9.468 0 17.143-7.675 17.143-17.142 0-9.468-7.675-17.143-17.143-17.143-9.467 0-17.143 7.675-17.143 17.143 0 9.467 7.676 17.142 17.143 17.142z", fill: "#000" }),
        react_1.default.createElement("path", { d: "M59.979 42.504H8.57c0-15.783 12.793-28.575 28.575-28.575h45.718c15.782 0 28.575 12.792 28.575 28.575", fill: "#007562" })));
};
exports.default = BrandIconCallUs;
